import { useCallback } from "react";
import { getBondPrincipalFieldConfig, gPrincipalVal } from "../bondPrincipalFieldConfig";
import { useBondPrincipalGuardianPatch } from "./useBondPrincipalGuardianPatch";
import { useBondPrincipalPgFetch } from "./useBondPrincipalPgFetch";
import { useBondPrincipalAddressHandlers } from "./useBondPrincipalAddressHandlers";
import { useBondPrincipalAttorneyHandlers } from "./useBondPrincipalAttorneyHandlers";
import { useBondPrincipalPrincipalTypeHandlers } from "./useBondPrincipalPrincipalTypeHandlers";

/**
 * Bond principal handlers facade (google / zip / PG / attorney / type toggles).
 */
export function useBondPrincipalHandlers({ kind, data, updateData, dataRef, attorneys }) {
  const cfg = getBondPrincipalFieldConfig(kind);
  const keys = cfg.fieldKeys;

  const { updateGuardianAt, patchPrincipalField } = useBondPrincipalGuardianPatch(
    data,
    updateData,
    keys
  );

  const { fetchProfessionalGuardianDetails } = useBondPrincipalPgFetch({
    cfg,
    keys,
    updateData,
    dataRef,
  });

  const { handleGoogleCallback, handleZipCodeChange } = useBondPrincipalAddressHandlers({
    cfg,
    keys,
    data,
    updateData,
    dataRef,
  });

  const { handleAttorneySelection, handleAttorneyHomeAddressChange } =
    useBondPrincipalAttorneyHandlers({
      cfg,
      keys,
      data,
      updateData,
      attorneys,
    });

  const { handleProfessionalGuardianChange, handleAttorneyChange } =
    useBondPrincipalPrincipalTypeHandlers({
      cfg,
      keys,
      data,
      updateData,
      updateGuardianAt,
    });

  const formatSSN = useCallback((ssn) => {
    if (!ssn || ssn.length < 4) return ssn || "";
    return "XXX-XX-" + ssn.slice(-4);
  }, []);

  return {
    cfg,
    keys,
    gVal: gPrincipalVal,
    updateGuardianAt,
    fetchProfessionalGuardianDetails,
    handleGoogleCallback,
    handleZipCodeChange,
    handleAttorneySelection,
    handleAttorneyHomeAddressChange,
    handleProfessionalGuardianChange,
    handleAttorneyChange,
    formatSSN,
    patchPrincipalField,
  };
}
